import { axios, Response } from '../../index'

export type ChangePasswordWithSecretCodeRequest = {
  code: string
  userEmail: string
  newPassword: string
}

const changePasswordWithSecretCode = (
  request: ChangePasswordWithSecretCodeRequest
): Response<null> => {
  return axios.put(`/v1/users/passwords/codes`, request)
}

export default changePasswordWithSecretCode
